// var getStockName = require('./methods/get-stock-name');

// import getStockUnit from './methods/get-stock-unit';
// import deleteAlert from './methods/delete-alert';
// import showDeleteConfirmation from './methods/delete-confirmation';
// import showSuccessAlert from './methods/show-success-alert';
// import showWarningAlert from './methods/show-warning-alert';
// import arrayToStrList from './methods/array-str-list';
// import getOutletList from './methods/get-outlet-list';
// import getAllOutletList from './methods/get-all-outlet-list';
// import getStaffList from './methods/get-staff-list';
// import getSupplierList from './methods/get-supplier-list';
// import getInventoryList from './methods/get-inventory-list';
// import getInventories from './methods/get-inventories';
// import filterStockList from './methods/filter-stock-list';
// import strPadNumber from './methods/str-pad-number';
// import showConfirmationSubmitAlert from './methods/show-confirmation-submit-alert';
// import confirmSubmit from './methods/confirm-submit';

export default {
    methods: {
        // showDeleteAlert: deleteAlert,
        // showDeleteConfirmation: showDeleteConfirmation,
        // getStockDisplayName: getStockName,
        // showSuccessAlert: showSuccessAlert,
        // arrayToStrList: arrayToStrList,
        // getOutletList: getOutletList,
        // getAllOutletList: getAllOutletList,
        // getStaffList: getStaffList,
        // getSupplierList: getSupplierList,
        // getInventoryList: getInventoryList,
        // getInventories: getInventories,
        // filterStockList: filterStockList,
        // showWarningAlert: showWarningAlert,
        // strPadNumber: strPadNumber,
        // showConfirmationSubmitAlert: showConfirmationSubmitAlert,
        // getStockUnit: getStockUnit,
        // confirmSubmit: confirmSubmit,
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/index.js